import DefaultLayout from './default-layout'

export default DefaultLayout
